<template>
  <div class="subHeaderGrey">
    <slot />
  </div>
</template>

<script>
  export default {
    name: "SubHeaderGrey"
  }
</script>

<style lang="scss">
  @import "../../../scss/_utilities/_variables";
  .subHeaderGrey{
    background-color: $color-gray-light !important;
    color: $color-black;
    padding: pxToRem(6) pxToRem(6) pxToRem(0) pxToRem(6);
    font-size: pxToRem(16);
    font-weight: 400;
  }
</style>
